package com.ives.modules.measurements;

import com.er453r.hxcompo.Component;

import com.ives.utils.math.Vector2D;
import com.ives.utils.math.Vector3D;

class Pointer extends Component{
	public var id:String;
	public var image:Vector3D;
	public var value:String;

	public function new(id:String, image:Vector3D) {
		this.id = id;
		this.image = image;

		name.innerHTML = id;
	}

	public function setLocalPosition(local:Vector2D) {
		viewElement.style.top = '${local.y}px';
		viewElement.style.left = '${local.x}px';
	}

	public function setImagePosition(x:Float, y:Float, z:Float) {
		image.x = x;
		image.y = y;
		image.z = z;
	}

	public function setValue(value:String) {
		this.value = value;

		name.innerHTML = id + " " + value;
	}
}
